{
  "videos": [
    {
      "title": "Механизм сдачи домашних заданий № 2 - 6",
      "url": "https://www.youtube.com/watch?v=wabSW_sz_cM"
    },
    {
      "title": "Модуль 1 Занятие 1 Основы Node.js 2",
      "url": "https://www.youtube.com/watch?v=UK65gJgYYfg"
    },
    {
      "title": "Модуль 1 Занятие 2 Основы Node.js. 11.02.21",
      "url": "https://www.youtube.com/watch?v=Rv1wDrwTOSU"
    },
    {
      "title": "Модуль 2 Занятие 3 Express. 16.02.21",
      "url": "https://www.youtube.com/watch?v=sItLTrP8FvY"
    },
    {
      "title": "Модуль 2 Занятие 4 Express. 18.02.21",
      "url": "https://www.youtube.com/watch?v=Tu9BFvJny1A"
    },
    {
      "title": "Модуль 3 Занятие 5 REST API. MongoDB и Mongoose. 22.02.21",
      "url": "https://www.youtube.com/watch?v=KjgqrretcoM"
    },
    {
      "title": "Занятие 6 REST API, MongoDB и Mongoose. 24.02.21",
      "url": "https://www.youtube.com/watch?v=TcSlmjSG-Ow"
    },
    {
      "title": "Занятие 7 Аутентификация. 01.03.21",
      "url": "https://www.youtube.com/watch?v=ydNH8HvjeKI"
    },
    {
      "title": "Занятие 8 Аутентификация. 03.03.2021",
      "url": "https://www.youtube.com/watch?v=GA9BFCsyeGk"
    },
    {
      "title": "Занятие 9 Работа с изображениями Тестирование 08.03.21",
      "url": "https://www.youtube.com/watch?v=DSvWl69ONB8"
    },
    {
      "title": "Занятие 10 Работа с изображениями Тестирование 10.03.21",
      "url": "https://www.youtube.com/watch?v=bFQqV7BEvSM"
    },
    {
      "title": "Занятие 11 Почта. Вебсокеты 15.03.21",
      "url": "https://www.youtube.com/watch?v=GSe0oJ5ISjA"
    },
    {
      "title": "Занятие 12 Почта. Вебсокеты 17.03.21",
      "url": "https://www.youtube.com/watch?v=d0RVdAUlK4c"
    },
    {
      "title": "Дополнительная лекция 23.03.21",
      "url": "https://www.youtube.com/watch?v=BZRDp2L_Mgo"
    },
    {
      "title": "Дополнительная лекция 24.03.21",
      "url": "https://www.youtube.com/watch?v=wq_7ITa3Nf8"
    },
    {
      "title": "Вебинар swagger-ui-express & Google OAUTH2",
      "url": "https://www.youtube.com/watch?v=oQaoymCOW8o"
    },
    {
      "title": "Старт командного проекта. Soft skills. 01.04.21",
      "url": "https://www.youtube.com/watch?v=1P7W8bDcIEA"
    }
  ],
  "materials": [
    {
      "title": "nodejs-homeworks",
      "url": "https://github.com/goitacademy/nodejs-homework"
    },
    {
      "title": "lesson code",
      "url": "https://drive.google.com/drive/folders/1f3faZuAsrlkqhYyTIV-8Morm4eGdrfPN"
    }
  ]
}
